import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Row, Col, Card, CardBody, Button } from "reactstrap";
import Table from "../Table";

const DeletedBLogs = ({
  tableHeading = [],
  tableData = [],
  handleViewBlogs,
  handleRestoreBlogs,
  handleTablePageChange,
  isLoading,
  page,
  sizePerPage,
  totalSize,
}) => {
  const history = useHistory();
  const [rowData, setRowData] = useState([]);
  console.log(tableData, "td");
  const viewBlogsFormatter = (cell, row) => {
    return (
      <div style={{ textAlign: "center" }} key={row._id}>
        <i
          className="ri-play-list-fill text-info h4 cursor-pointer mr-2"
          onClick={() => handleViewBlogs(row._id)}
        />
      </div>
    );
  };

  const restoreFormatter = (cell, row) => {
    return (
      <div style={{ textAlign: "center" }} key={row._id}>
        <Button
          color="success"
          className="waves-effect waves-light"
          style={{ width: "100%" }}
          onClick={() => handleRestoreBlogs(row._id)}
        >
          Restore
        </Button>
      </div>
    );
  };

  useEffect(() => {
    tableHeading.push({
      text: "View Blogs",
      dataField: "view",
      isDummyField: true,
      headerStyle: { textAlign: "center", width: "10%" },
      formatter: viewBlogsFormatter,
    });
    tableHeading.push({
      text: "Restore Blogs",
      dataField: "restore",
      isDummyField: true,
      headerStyle: { textAlign: "center", width: "10%" },
      formatter: restoreFormatter,
    });
    return () => {
      tableHeading.pop();
      tableHeading.pop();
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (tableData) {
      var result = tableData.map(function (el, i) {
        var o = Object.assign(
          {
            ...el,
            name: el.title,
            description: el.excerpt?.replace(/<\/?p>/g, ""),
          },
          el
        );
        o.sNo = i + 1;
        return o;
      });
      setRowData(result);
    }
    // eslint-disable-next-line
  }, [tableData]);
  return (
    <Row>
      <Col lg={12}>
        rowData
        <Card>
          <CardBody>
            sNo
            <Row>
              <Col xs={12}>
                <div className="page-title-box d-flex align-items-center justify-content-between">
                  <h3 className="m-0">Blogs Bin</h3>
                  <div className="page-title-right">
                    <Button
                      color="primary"
                      className="waves-effect waves-light"
                      style={{ width: "100%" }}
                      onClick={() => history.push("/dashboard/Blogs/all")}
                    >
                      All Blogs
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>
            <Table
              rows={rowData}
              columns={tableHeading}
              onTableChange={handleTablePageChange}
              page={page}
              sizePerPage={sizePerPage}
              totalSize={totalSize}
              isLoading={isLoading}
            />
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default DeletedBLogs;
